import { Alert, Checkbox, FormControlLabel, FormHelperText, Stack, styled } from '@mui/material';
import { CandidateProfileFormData } from 'features/profile/types';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ConnectedSwitch, InfoLine } from 'shared/components';

export default function AllEmailsField() {
    const { control, formState: { errors } } = useFormContext<CandidateProfileFormData>();
    const { t } = useTranslation('profile');

    const isSubscribed = useWatch({ control, name: 'communicationPreferences.unspecified' });
    const reconsentError = errors.emailResubscribeConfirmed;

    return (
        <Stack rowGap={ 2 }>
            { !isSubscribed && (
                <Alert severity="warning">
                    { t('edit.sections.communicationPreferences.unsubscribedInfo') }
                </Alert>
            ) }

            <InfoLine
                title={ t('edit.sections.communicationPreferences.allEmails.title') }
                description={ t('edit.sections.communicationPreferences.allEmails.description') }
                trailing={ <ConnectedSwitch control={ control }
                    name="communicationPreferences.unspecified"
                /> }
            />

            { isSubscribed && (
                <ReconsentBox>
                    <Controller control={ control }
                        name="emailResubscribeConfirmed"
                        render={ ({ field: { value, onChange, ref } }) => (
                            <FormControlLabel
                                control={
                                    <Checkbox checked={ !!value }
                                        inputRef={ ref }
                                        onChange={ (e) => onChange(e.target.checked) }
                                    />
                                }
                                label={ t('edit.sections.communicationPreferences.reconsent.label') }
                            />
                        ) }
                    />

                    { reconsentError && (
                        <FormHelperText error>
                            { t('edit.sections.communicationPreferences.reconsent.error') }
                        </FormHelperText>
                    ) }
                </ReconsentBox>
            ) }
        </Stack>
    );
}

const ReconsentBox = styled(Stack)(({ theme }) => ({
    paddingLeft: theme.spacing(4)
}));
